const getters = {
  personRnr: state => state.rnr.person,
  protocal: state => state.rnr.protocal,
  protocalMarkup: state => state.markup.protocal,
  enterpriseRnr: state => state.rnr.enterprise,
  personMarkup: state => state.markup.person,
  enterpriseMarkup: state => state.markup.enterprise,
  ocrMakrup: state => state.markup.ocrPic,
  loginUser: state => state.user.loginUser,
  isNFCDevice: state => state.device.isNFCDevice,
  dict: state => state.dict.dict,
  logo: state => state.dict.logo,
  agreement: state => state.dict.agreement
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js